export const eventsFallback = [
  
];
